<div class="loading-state-container">
  <!-- Spinner -->
  <mat-spinner [diameter]="spinnerDiameter" class="loading-state-spinner"></mat-spinner>

  <!-- Mensaje -->
  <p class="loading-state-message">{{ message }}</p>

  <!-- Descripción opcional -->
  <p *ngIf="description" class="loading-state-description">
    {{ description }}
  </p>
</div>
